import { Component, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IaChatComponent } from '../../ia-chat.component';

@Component({
    selector: 'ia-chat-launcher-bubble',
    imports: [TranslatePipe, IaChatComponent],
    templateUrl: './ia-chat-launcher-bubble.component.html',
    styleUrl: './ia-chat-launcher-bubble.component.scss',
})
export class IaChatLauncherBubbleComponent {
    public orderId = input<string | null>(null);
    /**
     * `true` = o chat abre já com destino DOCUMENTO AVULSO (feed → "Novo
     * documento → Usar o chat"): a pergunta "onde salvar?" não aparece.
     */
    public standalone = input<boolean>(false);
    /** Texto digitado fora do chat (tela sem seleção), entregue como rascunho. */
    public initialDraft = input<string>('');
    /**
     * Esconde a BOLINHA, não o chat: telas que já oferecem a IA no corpo (a tela sem
     * seleção, com o campo "descreva e a IA monta") não precisam do convite flutuante
     * por cima. O componente segue montado, porque é ele quem abre o chat.
     */
    public hideLauncher = input<boolean>(false);
    public opened = output<void>();
    public closed = output<void>();
    /** Emite o orderId quando o chat gera o documento ('' = documento avulso). */
    public concluded = output<string>();

    public isOpen = signal(false);

    public open(): void {
        this.opened.emit();
        this.isOpen.set(true);
    }

    public close(): void {
        this.isOpen.set(false);
        this.closed.emit();
    }
}
